import React from 'react';
import ButtonPrimary from '../Form/ButtonPrimary';
import { useCartContext } from '../../Contexts/CartContext';
import { formatCartId, formatCurrency } from '../../Utils/Formatters';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useLocation, useNavigate } from 'react-router-dom';
import SelectedProduct from './Product/SelectedProduct';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import { TbClockSearch } from 'react-icons/tb';

const FooterCart = () => {

  const { setShowCart, currentCart, getTotalQuantityProductsInConference, loadingUpdateQuantity, loadingCurrentCart } = useCartContext();
  const { isDelivery } = useOrderTypeContext();
  const { getLinkToHome } = useStoreHook();
  const { order } = useCheckoutContext();
  const location = useLocation();
  const isHome = location.pathname === getLinkToHome();

  const navigate = useNavigate();
  const goToOrderPlace = () => {
    navigate(`${getLinkToHome()}/order/${order.id}/placed`);
  }

  return (
    <>
      {(isHome && currentCart) &&
        <div className='
          fixed z-25 bottom-16 h-14
          flex w-full justify-between items-center gap-2 px-3 pl-4
          bg-custom-primary text-sm rounded-t-xl shadow-reverse-md
          text-white border-b-[1px] border-white
          '>
          <div className='grid text-xs w-full'>
            {(loadingUpdateQuantity || loadingCurrentCart)
                ? <div className="flex flex-col gap-1 animate-pulse">
                    <div className="bg-gray-600 h-2 rounded-full w-6"></div>
                    <div className="bg-gray-600 h-3 rounded-full w-16"></div>
                  </div>
                : currentCart.items.length === 0
                    ? <div className='font-medium text-gray-200 leading-none'>Selecione os produtos e faça seu pedido</div>
                    :
                      <>
                        <div className='font-medium'>
                          <span>Total</span>
                          {isDelivery &&
                            <>
                              {((currentCart.total_with_discount + currentCart.extra_tax > 0) || (currentCart.total_with_discount + currentCart.extra_tax === 0 && currentCart.extra_tax > 0))
                                  ? <> com <span className='text-shopfood-success font-bold'>entrega grátis</span></>
                                  : <span> com taxa de entrega de { formatCurrency(0) }</span>
                              }
                            </>
                          }
                        </div>
                        <div className='flex items-center gap-1.5'>
                          <span className='text-base font-black text-nowrap leading-4'>
                            {formatCurrency(Number(currentCart.total_with_discount) + Number(currentCart.extra_tax))}
                          </span>
                        </div>
                      </>
              }
          </div>

          {order &&
            <ButtonPrimary
                onClick={goToOrderPlace}
                className='text-white items-center gap-0.5 text-nowrap h-8 w-20 ring-transparent'>
                <div><TbClockSearch size={25} className='opacity-70' /></div>
                <div className="grid text-sm text-left leading-none">
                  <span className='text-[11px] opacity-70'>Pedido</span>
                  <span className='font-extrabold'>{ Number(formatCartId(order.id)) }</span>
                </div>
            </ButtonPrimary>
          }

          <ButtonPrimary 
            disabled={currentCart.items.length === 0}
            onClick={() => setShowCart(true)} className='relative ml-1 items-center text-nowrap h-8 ring-white hover:ring-white rounded-lg'>
            Ver carrinho
            <SelectedProduct alwaysNotify={loadingCurrentCart || loadingUpdateQuantity || currentCart.items.length > 0} loading={loadingCurrentCart || loadingUpdateQuantity} animated={false} quantity={currentCart ? getTotalQuantityProductsInConference(currentCart.items) : 0} className="rounded-lg -top-1 -right-1" />
          </ButtonPrimary>

        </div>
      }
    </>
  )
}

export default FooterCart;